module.exports = __webpack_public_path__ + "images/emoji/jack_o_lantern.55ade9104985cd302fd1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/jack_o_lantern.png
// module id = KXRe
// module chunks = 1